<template>
  <div class="introduction-require">
    <h3 v-if="title">{{title}}</h3>
    <ul v-if="list && list.length > 0">
      <li v-for="item in list" :key="item">{{item}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "../styles/variable.styl";

.introduction-require {
  margin-bottom: 20px;
  padding: 40px 60px;

  line-height: 1;
  background-color: #fff;
  color: $ucar_font_color;

  h3 {
    text-align: center;
    margin-bottom: 30px;
    font-size: $ucar_font_h4;
    font-weight: bold;
  }

  ul {
    padding-left: 15px;

    li {
      list-style: disc;
      font-size: $ucar_font_h6;
      line-height: 1.5;
      margin-bottom: 15px;
    }
  }
}
</style>
